import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectS3PathFromPeriod } from "../../services/submissionPeriod/slices";
import { SESSION_KINDS } from "../../util/constants";
import { useGetAllSessionsQuery } from "../../services/submissionPeriod/api";
import { useDownloadJsonDataQuery } from "../../services/storage/api";

function useQuestionsFromS3Path() {
  const { isLoading: sessionsLoading } = useGetAllSessionsQuery({ type: SESSION_KINDS.FGC });
  const { year, period, formType } = useParams();
  const indexPage = !year && !period && !formType
  const s3Path = useSelector((state) => {
    const path = !indexPage ? selectS3PathFromPeriod(state, year, period, formType) : ""
    return path
  });
  const splitPath = s3Path.split('/').slice(3).join('/')
  const { data, isLoading: s3Loading } = useDownloadJsonDataQuery({
    path: splitPath,
    s3Path: s3Path,
  }, {
    skip: !splitPath
  });
  const questionIds = data?.questions?.map(({ id }) => id)

  return {
    ids: questionIds || [],
    s3Path: splitPath,
    isLoading: sessionsLoading || s3Loading,
    indexPage
  }
}

export default useQuestionsFromS3Path;
